import React from 'react';
import { useRouter } from 'next/router';
import ProductDetail from '../components/Products/ProductDetail';
import Layout from '../components/Layout';
import productQuery from '../lib/queries/products/productQuery.graphql';
import withApollo from '../lib/apollo';
import redirectRouteToDomain from '../lib/redirectRouteToDomain';
import {
  productAnchorImageConfigurations,
  productLightboxImageConfigurations,
} from '../lib/imageConfigurations';

const isFashionFinder = (marketId) => Number(marketId) === 8;

const ProductPage = () => {
  const { query: { id, marketId, standId } } = useRouter();
  const variables = {
    id: Number(id),
    marketId: marketId && Number(marketId),
    standId: standId && Number(standId),
    anchorImageConfigurations: productAnchorImageConfigurations,
    lightboxImageConfigurations: productLightboxImageConfigurations,
  };

  return (
    <ProductDetail
      query={productQuery}
      variables={variables}
      errorMessage="Error loading this product info"
      passErrors={['Access denied']}
      backToProductsRoute="products"
      buyText={isFashionFinder(marketId)}
      {...variables}
    />

  );
};

ProductPage.getLayout = (page) => (
  <Layout
    layoutMaxWidth="none"
  >
    {page}
  </Layout>
);

ProductPage.getInitialProps = redirectRouteToDomain(
  'product',
);

export default withApollo(ProductPage);
